import React, { Component } from "react";
import PropTypes from "prop-types";
import { logError } from "@utils/errorLogger";
import Modal from "../Modal/Modal";

import "./ErrorBoundary.scss";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	componentDidCatch(error, { componentStack }) {
		const {
			user: { Id },
		} = this.props;
		this.setState({ hasError: true });

		logError(error, componentStack, Id);
	}

	render() {
		const { lang } = global;
		const { hasError } = this.state;
		const { children } = this.props;

		if (hasError) {
			return (
				<div id="app-error">
					<Modal
						show
						backdrop="static"
					>
						<Modal.Header>
							<Modal.Title>{lang.t("Error")}</Modal.Title>
						</Modal.Header>
						<Modal.Body className="text-center">
							{lang.t(
								"RollKall has encountered an error_ Our team has been notified of this issue_",
							)}
						</Modal.Body>
						<Modal.Footer>
							<a
								href="/"
								className="btn btn-primary"
							>
								{lang.t("Ok")}
							</a>
						</Modal.Footer>
					</Modal>
				</div>
			);
		}
		return children;
	}
}

ErrorBoundary.propTypes = {
	user: PropTypes.object,
	children: PropTypes.any.isRequired,
};

ErrorBoundary.defaultProps = { user: {} };

export default ErrorBoundary;
